<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:15px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace1"
                @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item label="公司名：" prop="name">
              <el-input v-model="form.organizationName" placeholder="请输入公司名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="统计起始日期：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.startTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束日期：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.endTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:api,data:form,callback:_d => tableData = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-show="admin || subAdmin" type="danger" @click="deleteDate('dwzp')">删除</el-button>
      <el-button style="padding: 0"><file_Upload :_url="$public.upload_url._y"></file_Upload></el-button>
      <el-button type="primary"  @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/单位招聘导入模板.xls" download="单位招聘导入模板.xls">下载模板</a> -->
        下载模板
      </el-button>
      <el-button type="primary"
            v-show="admin"
            v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="单位招聘统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      @close="close"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">岗位信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="218px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="县区市：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="联系QQ：">
                          <el-input style="width:193px;" v-model="editForm.qq"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱：">
                          <el-input style="width:193px;" v-model="editForm.email"></el-input>
                        </el-form-item>
                        <el-form-item label="联系地址">
                          <el-input style="width:193px;" v-model="editForm.address"></el-input>
                        </el-form-item>
                        <el-form-item label="微信">
                          <el-input style="width:193px;" v-model="editForm.weixin"></el-input>
                        </el-form-item>
                        <el-form-item label="微博">
                          <el-input style="width:193px;" v-model="editForm.weibo"></el-input>
                        </el-form-item>
                        <el-form-item label="公司名称">
                          <el-input style="width:193px;" v-model="editForm.organizationName"></el-input>
                        </el-form-item>
                        <el-form-item label="所属行业">
                          <el-select size="mini" filterable v-model="editForm.belongToIndustry" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.suoshuhangye3g"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="公司性质">
                          <el-select size="mini" filterable v-model="editForm.organizationType" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.gongsixz"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="成立日期">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.setupTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="注册资金">
                          <el-select size="mini" filterable v-model="editForm.registerCash" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.zhucezijin"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="员工人数">
                          <el-select size="mini" filterable v-model="editForm.personCount" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.yuangongrenshu"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="注册号">
                          <el-input style="width:193px;" v-model="editForm.registerNo"></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址">
                          <el-input style="width:193px;" v-model="editForm.registerAddress"></el-input>
                        </el-form-item>
                        <el-form-item label="岗位类别">
                          <el-select size="mini" filterable v-model="editForm.jobType" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.gangweilb"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="职位名称">
                          <el-input style="width:193px;" v-model="editForm.jobName"></el-input>
                        </el-form-item>
                        <el-form-item label="公司简介">
                          <el-input type="textarea" v-model="editForm.organizationShowMsg" :rows="3"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="待遇水平">
                          <el-select size="mini" filterable v-model="editForm.salary" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.daiyushuiping"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="招聘部门">
                          <el-input style="width:193px;" v-model="editForm.department"></el-input>
                        </el-form-item>
                        <el-form-item label="招聘人数">
                          <el-input style="width:193px;" v-model="editForm.needPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="职位类别">
                          <el-select size="mini" filterable v-model="editForm.jobCatalog" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.zhiweileibie"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="工作地点（省）">
                          <el-input style="width:193px;" v-model="editForm.workAddressProvince"></el-input>
                        </el-form-item>
                        <el-form-item label="工作地点（市）">
                          <el-input style="width:193px;" v-model="editForm.workAddressCity"></el-input>
                        </el-form-item>
                        <el-form-item label="工作地点（区）">
                          <el-input style="width:193px;" v-model="editForm.workAddressCounty"></el-input>
                        </el-form-item>
                        <el-form-item label="学历要求">
                          <el-select size="mini" filterable v-model="editForm.education" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.dwzp_xl "
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="工作年限">
                          <el-select size="mini" filterable v-model="editForm.workYear" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.gongzuonianxian"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="性别要求">
                          <el-select size="mini" filterable v-model="editForm.sex" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.sexyaoqiu"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="工作地区">
                          <el-select size="mini" filterable v-model="editForm.workArea" placeholder="请选择">
                            <el-option
                              v-for="(item) in $public.gongzuodiqu"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="发布日期">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.publicTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="具体要求">
                          <el-input type="textarea" v-model="editForm.requireDetail" :rows="3"></el-input>
                        </el-form-item>
                        <el-form-item label="面试须知">
                          <el-input type="textarea" v-model="editForm.interview" :rows="3"></el-input>
                        </el-form-item>
                        <el-form-item label="职位描述">
                          <el-input type="textarea" v-model="editForm.jobDesc" :rows="3"></el-input>
                        </el-form-item>
                        <el-form-item label="年龄要求">
                          <el-input type="textarea" v-model="editForm.ageRequire" :rows="3"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      api:'/user/recruitUnit',
      form:{},
      type:'12',
      centerDialogVisible:false,
      tableData:[],
      selectRow:[],            
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'phone',value:'手机'},
        {key:'landline',value:'座机'},
        {key:'qq',value:'联系QQ'},
        {key:'email',value:'电子邮箱'},
        {key:'address',value:'联系地址'},
        {key:'weixin',value:'微信'},
        {key:'weibo',value:'微博'},
        {key:'organizationName',value:'公司名称'},
        {key:'belongToIndustry',value:'所属行业'},
        {key:'organizationType',value:'公司性质'},
        {key:'setupTime',value:'成立日期'},
        {key:'registerCash',value:'注册资金'},
        {key:'personCount',value:'员工人数'},
        {key:'registerNo',value:'注册号'},
        {key:'registerAddress',value:'公司地址'},
        {key:'organizationShowMsg',value:'公司简介'},
        {key:'jobType',value:'岗位类别'},
        {key:'jobName',value:'职位名称'},
        {key:'salary',value:'待遇水平'},
        {key:'department',value:'招聘部门'},
        {key:'needPersons',value:'招聘人数'},
        {key:'jobCatalog',value:'职位类别'},
        {key:'workAddressProvince',value:'工作地点（省）'},
        {key:'workAddressCity',value:'工作地点（市）'},
        {key:'workAddressCounty',value:'工作地点（区）'},
        {key:'education',value:'学历要求'},
        {key:'workYear',value:'工作年限'},
        {key:'sex',value:'性别要求'},
        {key:'requireDetail',value:'具体要求'},
        {key:'interview',value:'面试须知'},
        {key:'jobDesc',value:'职位描述'},
        {key:'workArea',value:'工作地区'},
        {key:'ageRequire',value:'年龄要求'},
        {key:'publicTime',value:'发布日期'},
            ],
      rules:{
        socialCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
      },
      isCreate:false,
    }
  },
  created() {
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },

    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.publicTime = new Date(newForm.publicTime).getTime()
      newForm.setupTime = new Date(newForm.setupTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
              this._status(res.data)
            }
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */

.el-textarea .el-textarea__inner{resize: none;}
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>